// Returns a copy of obj with every key that has a translation in dict renamed, keeping the
// original key order. The renaming is done by rebuilding the object rather than by assigning the
// new key and deleting the old one: a delete + re-add moves the renamed key to the END of the
// object's iteration order, and several consumers read that order as the display order (the sales
// decomposition components, the media mix, the spend charts). Arrays and non-objects pass through.
function renameKeys (obj, dict) {
  if (!obj || typeof obj !== 'object' || Array.isArray(obj)) {
    return obj
  }
  const renamed = {}
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      renamed[dict.hasOwnProperty(key) ? dict[key] : key] = obj[key]
    }
  }
  return renamed
}

// Translates keys for all sub-properties in each path in paths, using the translations defined in dict
function translateObjVals (obj, paths, dict) {
  let newObj = JSON.parse(JSON.stringify(obj))
  paths.forEach(path => {
    if (path === '') {
      newObj = renameKeys(newObj, dict)
    } else {
      let keys = path.split('.')
      let target = newObj
      for (let i = 0; i < keys.length - 1; i++) {
        if (target) {
          target = target[keys[i]]
        }
      }
      // At this point target contains the parent for the target object/array
      let lastKey = keys[keys.length - 1]
      if (target && target.hasOwnProperty(lastKey)) {
        if (!Array.isArray(target[lastKey])) {
          // Media pretty names are all in objects, some Components too
          target[lastKey] = renameKeys(target[lastKey], dict)
        } else {
          // Some Components pretty names are in arrays
          let subArr = target[lastKey]
          for (const [index, item] of subArr.entries()) {
            if (dict.hasOwnProperty(item.name)) {
              subArr[index] = {
                name: dict[item.name],
                value: item.value
              }
            }
          }
        }
      }
    }
  })
  return newObj
}

export const prettyNames = {
  methods: {
    prettyTranslateNames (obj, paths, dict) {
      if (dict && Object.keys(dict).length > 0) {
        // Add a prefix all to dict values, allows usage of original names in new names (but for different channels)
        let tempDict = {}
        for (const [key, value] of Object.entries(dict)) {
          tempDict[key] = `_te.mp_${value}`
        }
        // Translate to prefixed prettynames
        const tempObj = translateObjVals(obj, paths, tempDict)
        // Remove prefix from dict values, and use the prefixed names as keys
        let newDict = {}
        for (const [, value] of Object.entries(tempDict)) {
          if (value.startsWith('_te.mp_')) {
            newDict[value] = value.replace('_te.mp_', '')
          }
        }
        // Translate to unprefixed (intended) prettynames
        return translateObjVals(tempObj, paths, newDict)
      } else {
        return obj
      }
    }
  }
}
